module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"评价运营方式","review_permission":"评价撰写权限","review_publication_period":"评价展示期限","rating_criteria_and_impact":"评价标准及影响","review_deletion_criteria_and_appeal_procedures":"评价删除标准及异议处理程序"}}')
  delete Component.options._Ctor
}
